import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_admin/projects/$projectId/')({
	loader: ({ params }) => {
		throw redirect({
			to: '/projects/$projectId/events',
			params: { projectId: params.projectId },
		});
	},
	component: () => null,
});
